export const MAIN_CONTENT_ID = 'main-content';
export function getEndlessScrollMainId(isEndlessScrollArticle) {
  return isEndlessScrollArticle ? undefined : MAIN_CONTENT_ID;
}
